import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const rovoSearchRoute: InvariantJiraRoute = {
	name: 'jira-rovo-search',
	path: '/jira/cross-product-search',
	exact: true,
};
